import React from 'react';
import {Link, useLocation} from "react-router-dom";
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import {useTranslation} from "react-i18next";

function MerchantRegistrationBanner() {
	const {t} = useTranslation();
	const location = useLocation();
	if (location.pathname === "/merchant/registration") return null;
	return (
		<div className="mx-auto max-w-7xl px-4 sm:px-8 2xl:px-0 3xl:px-0 mt-2">
			<div className="relative isolate flex flex-col sm:flex-row items-center justify-between gap-x-6 gap-y-4 overflow-hidden bg-white/60 backdrop-blur-xl px-6 py-4 border border-gray-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] rounded-[2rem] 2xl:rounded-full">
				<div className="flex flex-wrap items-center gap-x-4 gap-y-2">
					<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-orange-50 border border-orange-100">
						<ExclamationTriangleIcon className="h-6 w-6 text-orange-500" />
					</div>
					<div>
						<p className="text-sm leading-6 text-gray-900">
							<strong className="font-bold text-gray-900">{t('registration.banner.title')}</strong>
							<span className="hidden sm:inline mx-2 text-gray-300">|</span>
							<span className="block sm:inline text-gray-500 font-medium">{t('registration.banner.description')}</span>
						</p>
					</div>
				</div>
				<Link
					to="/merchant/registration"
					className="flex-none rounded-full bg-gradient-to-br from-[#0b5f82] to-[#0b9cbc] px-6 py-2 text-sm font-bold text-white shadow-lg shadow-blue-900/10 hover:shadow-blue-900/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all duration-300 transform hover:scale-105 active:scale-95"
				>
					{t('registration.banner.setup_account')} <span aria-hidden="true" className="ltr:ml-1 rtl:mr-1">&rarr;</span>
				</Link>
			</div>
		</div>
	);
}

export default MerchantRegistrationBanner;
